import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Problem } from "@/components/Problem";
import { Product } from "@/components/Product";
import { Outputs } from "@/components/Outputs";
import { HowItWorks } from "@/components/HowItWorks";
import { UseCases } from "@/components/UseCases";
import { Value } from "@/components/Value";
// import { Pricing } from "@/components/Pricing"; // Hidden for now
import { FAQ } from "@/components/FAQ";
import { ContactUs } from "@/components/ContactUs";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";

const Index = () => {
  return (
    <div className="min-h-screen">
      <SEO />
      <Header />
      <main>
        <Hero />
        <Problem />
        <Product />
        <Outputs />
        <HowItWorks />
        <UseCases />
        <Value />
        {/* <Pricing /> Hidden for now */}
        <FAQ />
        <ContactUs />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
